import { SINGLETON_MODE } from 'js/components/common/PopupManager/constants';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { showConfirmationPopupAction } from 'js/components/common/popups/ConfirmationPopup';
import { sendRealityCheckNotification } from './server';

export const realityCheckPopupAction = ({ content, actionId }) => {
    publicEventsAPIService.trigger('realityPopup:shown');

    return showConfirmationPopupAction({
        id: actionId,
        singletonMode: SINGLETON_MODE.UPDATE,
        content,
        className: 'reality-check-popup',
        onAccept: () => {
            publicEventsAPIService.trigger('realityPopup:closed', 'accept');
            sendRealityCheckNotification(actionId, 'reset');
        },
        onDecline: () => {
            publicEventsAPIService.trigger('realityPopup:closed', 'decline');
            sendRealityCheckNotification(actionId, 'stopgaming');
        },
        acceptBtnText: 'playtech.mobile.system.realityCheckPopup.accept',
        declineBtnText: 'playtech.mobile.system.realityCheckPopup.decline'
    });
};
